import { useCallback, useEffect, useState } from "react";

interface ElementGeometry {
  width: number;
  height: number;
  top: number;
  left: number;
  right: number;
  bottom: number;
}

export function useElementGeometry(observeResize = true) {
  const [ref, setRef] = useState<HTMLElement | null>(null);
  const [geometry, setGeometry] = useState<ElementGeometry | null>(null);

  const handleResize = useCallback(() => {
    if (!ref) {
      return;
    }

    const rect = ref.getBoundingClientRect();
    setGeometry({
      width: rect.width,
      height: rect.height,
      top: rect.top,
      left: rect.left,
      right: rect.right,
      bottom: rect.bottom
    });
  }, [ref]);

  useEffect(() => {
    if (!ref) {
      return null;
    }

    handleResize();

    if (observeResize) {
      const resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(ref);

      return () => {
        resizeObserver.disconnect();
      };
    }

    return null;
  }, [ref, handleResize, observeResize]);

  return { ref: setRef, geometry };
}
